
export interface IInspectionForm {
  id?: number;
  companyId?: number;
  name?: string;
  version?: string;
  code?: string;
  dateFormat?: string;
  periodicityTypeId?: number;
  periodicityType?: string;
  periodicityValue?: number;
  description?: string; 
  equipmentId?: number;

}

export class InspectionForm implements IInspectionForm {
  id?: number;
  companyId?: number;
  name?: string;
  version?: string;
  code?: string;
  dateFormat?: string;
  periodicityTypeId?: number;
  periodicityType?: string;
  periodicityValue?: number;
  description?: string;
  equipmentId?: number;
  
}